import { createI18n } from 'vue-i18n'
import en from '../locales/en.json'
import fr from '../locales/fr.json'
import de from '../locales/de.json'
import it from '../locales/it.json'
import ja from '../locales/ja.json'
import pt from '../locales/pt.json'
import es from '../locales/es.json'
import he from '../locales/he.json'

export default defineNuxtPlugin((nuxtApp) => {
  let locale = 'en'

  if (import.meta.server) {
    // Get Accept-Language header during SSR
    const headers = useRequestHeaders()
    const acceptLanguage = headers['accept-language']

    if (acceptLanguage) {
      // Parse the Accept-Language header and get the first preferred language
      locale = acceptLanguage.split(',')[0].split('-')[0]
    }
  } else {
    // Client-side language detection
    locale = (navigator.language || navigator.userLanguage || 'en').split('-')[0]
  }

  const i18n = createI18n({
    locale,
    fallbackLocale: 'en',
    globalInjection: true,
    legacy: false,
    messages: {
      ja,
      de,
      en,
      fr,
      it,
      pt,
      es,
      he
    }
  })

  nuxtApp.vueApp.use(i18n)
  return {
    provide: {
      i18n
    }
  }
})
